import React from "react";
import classNames from "classnames";
import { setGlobal, useGlobal } from 'reactn';
import "./Header.scss"

const Header = () => {
  const [ showInfo ] = useGlobal("showInfo")

  return (
    <header className="header">
      <h1>
        <span className="title">
          Niklas May
        </span>
        <span className="title-mobile">
          NM
        </span>
        <span className="sub-title">
          Backlog
        </span>
      </h1>
      <button
        type="button"
        onClick={()=>setGlobal({showInfo: !showInfo})}
        className={classNames(showInfo && "active")}
      >
        <span>
          more
        </span>
      </button>
    </header>
  )
}

export default Header
